module.exports = __webpack_public_path__ + "static/flipgive-logo-7ed2452983afabba095fb93a1f12e6bf.jpg";